module.exports = __webpack_public_path__ + "components/layout/images/tencent.png?156dba2a";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/tencent.png
// module id = 243
// module chunks = 0